import React from 'react';
import { Box, Flex, Text, Heading, Button, DropdownMenu, Avatar } from '@radix-ui/themes';

const CourseView = ({course, selected = false, onSelect = () => {}}) => {
  return (
    <Flex direction="row" align="center" gap="2" p="1" pr="4" maxWidth="200px"
    style={{
        cursor:'pointer', 
        border: 'solid thin var(--gray-5)',
        borderColor: selected ? 'var(--green-11)' : 'var(--gray-5)',
        borderRadius:'5px'
    }}
    onClick={() => onSelect(course)}
    >
        <Avatar 
            src={course.teacher?.user.profile_picture} 
            fallback={course.teacher?.user.firstname[0] + course.teacher?.user.lastname[0]}
            size="3"
        />
        <Flex direction="column" align="start">
            <Text size="2" weight="bold">{course.subject.name}</Text>
            <Text size="1">{course.teacher?.user.firstname + " " + course.teacher?.user.lastname}</Text>
        </Flex>

    </Flex>
  );
};

export default CourseView;
